import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=6906d8d8&"
import script from "./RegistrationComplete.vue?vue&type=script&lang=ts&"
export * from "./RegistrationComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports